<script setup lang="ts">
import { computed, type PropType } from 'vue';
import { storeToRefs } from 'pinia';
import { StatisticsKind, useModulesConfigStore } from '@maximap-base';
import StatisticsTypeCard from './StatisticsTypeCard.vue';

const moduleConfigStore = useModulesConfigStore();
const { moduleConfig } = storeToRefs(moduleConfigStore);

const props = defineProps({
  modelValue: {
    type: String as PropType<StatisticsKind>
  },
  size: {
    type: Number,
    default: 212
  }
});

const emit = defineEmits(['update:modelValue']);

const selectedKind = computed(() => props.modelValue);

const onKindSelect = (kind: StatisticsKind) => {
  emit('update:modelValue', kind);
};
</script>

<template>
  <div class="d-flex flex-row gap-2 align-center">
    <statistics-type-card
      v-for="(statisticsKindOption, index) in moduleConfig.statistics.statisticsTypeOptions"
      :key="index"
      :title="$t(statisticsKindOption.title)"
      :value="statisticsKindOption.kind"
      :selected="selectedKind === statisticsKindOption.kind"
      :enabled="statisticsKindOption.enabled"
      :size="size"
      @click="onKindSelect">
      <template
        #icon="{ color }"
        v-if="statisticsKindOption.icon">
        <component
          :is="statisticsKindOption.icon"
          :color="color"></component>
      </template>
    </statistics-type-card>
  </div>
</template>
